// extracted by mini-css-extract-plugin
export var callCard = "_jn-0";
export var callMessageButton = "_jn-1";
export var helpIcon = "_jn-3";
export var helpIconContainer = "_jn-4";
export var verticalDivider = "_jn-2";